"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import SectionHeading from "../shared/SectionHeading";
import "swiper/swiper-bundle.css";
import "../common/Achievements.scss";

const Achievements = ({ data }) => {
  const IMAGE_BASE = process.env.REACT_APP_IMAGE_URL;

  if (!data.section[4].isActive) {
    return <div></div>;
  }

  return (
    <div className="achievements-wrapper">
      <SectionHeading>
        <span className="text-primary-color">Learner&apos;s</span>{" "}
        <span className="text-secondary-color">Achievement</span>
      </SectionHeading>

      <div className="swiper-container">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.2, spaceBetween: 24 },
            768: { slidesPerView: 2, spaceBetween: 28 },
            1024: { slidesPerView: 3, spaceBetween: 32 },
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: true,
          }}
          navigation
          className="achievements-swiper"
        >
          {data.section[4].body.list1.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="achievements-card">
                <div className="card-image">
                  <img
                    src={`${IMAGE_BASE}/${item.image}`}
                    alt={item.text}
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="card-text">{item.text}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Achievements;
